import template from './document-settings-edit.html';
import controller from './document-settings-edit.controller';
import './document-settings-edit.scss';

const documentSettingsEditComponent = {
  bindings: {
    modalInstance: '<?',
    resolve: '<?'
  },
  template,
  controller,
  controllerAs: 'vm'
};

controller.$inject = ['$scope', '$rootScope', 'fileRequest', 'utils'];

export default documentSettingsEditComponent;
